import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { TbCircleLetterDFilled } from 'react-icons/tb';

import { useTranslation } from '../../../common/hooks/useTranslation';
export const DuplicateInvoice: React.FC = () => {
  const { t, tk } = useTranslation('fvsLng');

  return (
    <OverlayTrigger
      overlay={<Tooltip>{t(tk.sendEmail.invoiceDuplicate)}</Tooltip>}
    >
      <span className="px-2">
        <TbCircleLetterDFilled size={22} className="icon-blue" />
      </span>
    </OverlayTrigger>
  );
};
